$(document).ready(function(){
	function anchors(){
		var anchors = [];
		var anchorSections = [];

		$(".tab-navigation .anchor").map(function(i, e){
			anchors.push($(e));
			$(e).attr("data-index", i);
		});

		$(".anchor-section").map(function(i, e){
			anchorSections.push($(e));
			$(e).attr("data-index", i);
		});

		$(".tab-navigation .anchor").on("click", function(e){
			e.preventDefault();
			var index = $(this).data("index");
			$("html, body").animate({scrollTop: $(anchorSections[index]).offset().top - 80}, 500);
		});
	}

	function calculator(){
		$(".calculator .dropdown .number").on("click", function(){
			$(this).parent().find(".range").addClass("active");
		});

		$(document).on("click", function(e) {
			if($(e.target).closest(".calculator .dropdown .number").length == 0 && $(e.target).closest(".range").length == 0) {
				$(".range").removeClass("active");
			}
		});

		$(".range input").each(function(){
			$(this).val($(this).parent().parent().find(".number").val());

			var min = $(this).attr("min");
			var max = $(this).attr("max");

			$(this).parent().find(".min").html(min);
			$(this).parent().find(".max").html(max);
		});

		$(".range input").on("change input", function(){
			var amount = $(this).val();
			$(this).parent().parent().find(".number").val(amount);
		});

		$(".calculator .dropdown .number").on("change input", function(){
			var amount = $(this).val();
			$(this).parent().find(".range input").val(amount);
		});
		
		$(".calculate").on("click", function(){
			$(".calculator .result").css("display", "block");
			$(".calculator .disclaimer").css("display", "block");
		});
	}

	function currencyDropdown(){
		$(".currency").on("click", function(){
			$(this).find(".dropdown").toggleClass("active");
		});

		$(document).on("click", function(e) {
			if($(e.target).closest(".currency").length == 0) {
				$(".currency .dropdown").removeClass("active");
			}
		});

		$(".currency .dropdown ul li").on("click", function(){
			$(".currency .blue").html($(this).html());
		});
	}

	function gallery(){
		var galerija = $('.gallery.galerija a').simpleLightbox();
		var tlocrt = $('.gallery.tlocrt a').simpleLightbox();

		$(".tab-navigation .tlocrt").on("click", function(e){
			e.preventDefault();
			$('.gallery.tlocrt a').trigger("click");
		});
		$(".tab-navigation .galerija").on("click", function(e){
			e.preventDefault();
			$('.gallery.galerija a').trigger("click");
		});
		$(".tab-navigation .video").on("click", function(e){
			e.preventDefault();
			$($('.photoswipe-wrapper a')[0]).trigger("click");
		});

		$(".estate-image .image").on("click", function(){
			$('.gallery.galerija a').trigger("click");
		});
	}

	function videoGallery(){
		$(".video-link").jqueryVideoLightning({
			autoplay: 0
		});
	}

	function shareOpener(){
		$(".box.print").on("click", function(e){
			e.preventDefault();
			print();
		});

		$(".box.share").on("click", function(e){
			e.preventDefault();
			$(this).toggleClass("active");
			$(".share-wrapper.share-header").toggleClass("active");
		});

		$(".image .share").on("click", function(e){
			e.preventDefault();
			$(this).toggleClass("active");
			$(".share-wrapper.share-header").toggleClass("active");
		});

		$(document).on("click", function(e) {
			if($(e.target).closest(".box.share").length == 0 && $(e.target).closest(".image .share").length == 0) {
				$(".box.share").removeClass("active");
				$(".share-wrapper.share-header").removeClass("active");
				$(".image .share").removeClass("active");
			}
		});
	}

	function stickyNavigation(){	
		$(window).on("scroll resize", function(){
			var tabNav = $("header").height() + $(".breadcrumb").height() + $(".estate-image").height();
			if($(window).scrollTop() >= tabNav){
				$(".tab-navigation").addClass("fixed");
				$(".share-wrapper.share-header").addClass("fixed");
				$(".calculator .basic-data").addClass("fixed");

				var tabsWrapper = $(".tabs-wrapper").width();
				var right = (($(window).width()) - tabsWrapper) / 2;

				$(".share-wrapper.share-header").css({
					"right": right + "px"
				});
				$(".calculator .basic-data").css({
					"right": right + "px"
				});
			}
			else{
				$(".tab-navigation").removeClass("fixed");
				$(".share-wrapper.share-header").removeClass("fixed");
				$(".calculator .basic-data").removeClass("fixed");

				$(".share-wrapper.share-header").css({
					"right": "0"
				});
			}

			if($(window).scrollTop() >= $(".bottom-sticky").offset().top - $(".calculator .basic-data").height() - 160){
				$(".calculator .basic-data").addClass("fixed-bottom");
				$(".calculator .basic-data").css("right", "0px");
				$(".calculator").css("position", "static");
			}
			else if($(window).scrollTop() <= $(".sticky-wrapper").offset().top){
				$(".calculator").css("position", "absolute");
			}
			else{
				$(".calculator .basic-data").removeClass("fixed-bottom");
			}
			
		});
	}

	$('.photoswipe-wrapper').each(function() {
		$(this).find('a').each(function() {
			$(this).attr('data-size', $(this).find('img').get(0).naturalWidth + 'x' + $(this).find('img').get(0).naturalHeight);
		});
	});

	var initPhotoSwipeFromDOM = function(gallerySelector) {

		var parseThumbnailElements = function(el) {
			var thumbElements = $(el).find('.photoswipe-item:not(.isotope-hidden)').get(),
			numNodes = thumbElements.length,
			items = [],
			figureEl,
			linkEl,
			size,
			item;

			for (var i = 0; i < numNodes; i++) {

				figureEl = thumbElements[i];

				if (figureEl.nodeType !== 1) {
					continue;
				}

				linkEl = figureEl.children[0];

				size = linkEl.getAttribute('data-size').split('x');

				if ($(linkEl).data('type') == 'video') {
					item = {
						html: $(linkEl).data('video')
					};
				} else {
					item = {
						src: linkEl.getAttribute('href'),
						w: parseInt(size[0], 10),
						h: parseInt(size[1], 10)
					};
				}

				if (figureEl.children.length > 1) {
					item.title = $(figureEl).find('.caption').html();
				}

				if (linkEl.children.length > 0) {
					item.msrc = linkEl.children[0].getAttribute('src');
				}

				item.el = figureEl;
				items.push(item);
			}

			return items;
		};

		var closest = function closest(el, fn) {
			return el && (fn(el) ? el : closest(el.parentNode, fn));
		};

		function hasClass(element, cls) {
			return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
		}

		var onThumbnailsClick = function(e) {
			e = e || window.event;
			e.preventDefault ? e.preventDefault() : e.returnValue = false;

			var eTarget = e.target || e.srcElement;

			var clickedListItem = closest(eTarget, function(el) {
				return (hasClass(el, 'photoswipe-item'));
			});

			if (!clickedListItem) {
				return;
			}

			var clickedGallery = clickedListItem.closest('.photoswipe-wrapper'),
			childNodes = $(clickedListItem.closest('.photoswipe-wrapper')).find('.photoswipe-item:not(.isotope-hidden)').get(),
			numChildNodes = childNodes.length,
			nodeIndex = 0,
			index;

			for (var i = 0; i < numChildNodes; i++) {
				if (childNodes[i].nodeType !== 1) {
					continue;
				}

				if (childNodes[i] === clickedListItem) {
					index = nodeIndex;
					break;
				}
				nodeIndex++;
			}

			if (index >= 0) {
				openPhotoSwipe(index, clickedGallery);
			}
			return false;
		};

		var photoswipeParseHash = function() {
			var hash = window.location.hash.substring(1),
			params = {};

			if (hash.length < 5) {
				return params;
			}

			var vars = hash.split('&');
			for (var i = 0; i < vars.length; i++) {
				if (!vars[i]) {
					continue;
				}
				var pair = vars[i].split('=');
				if (pair.length < 2) {
					continue;
				}
				params[pair[0]] = pair[1];
			}

			if (params.gid) {
				params.gid = parseInt(params.gid, 10);
			}

			return params;
		};

		var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
			var pswpElement = document.querySelectorAll('.pswp')[0],
			gallery,
			options,
			items;

			items = parseThumbnailElements(galleryElement);

			options = {

				closeOnScroll: false,

				galleryUID: galleryElement.getAttribute('data-pswp-uid'),

				getThumbBoundsFn: function(index) {
					var thumbnail = items[index].el.getElementsByTagName('img')[0],
					pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
					rect = thumbnail.getBoundingClientRect();

					return {
						x: rect.left,
						y: rect.top + pageYScroll,
						w: rect.width
					};
				}

			};

			if (fromURL) {
				if (options.galleryPIDs) {
					for (var j = 0; j < items.length; j++) {
						if (items[j].pid == index) {
							options.index = j;
							break;
						}
					}
				} else {
					options.index = parseInt(index, 10) - 1;
				}
			} else {
				options.index = parseInt(index, 10);
			}

			if (isNaN(options.index)) {
				return;
			}

			if (disableAnimation) {
				options.showAnimationDuration = 0;
			}

			gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
			gallery.init();

			gallery.listen('beforeChange', function() {
				var currItem = $(gallery.currItem.container);
				$('.pswp__video').removeClass('active');
				var currItemIframe = currItem.find('.pswp__video').addClass('active');
				$('.pswp__video').each(function() {
					if (!$(this).hasClass('active')) {
						$(this).attr('src', $(this).attr('src'));
					}
				});
			});

			gallery.listen('close', function() {
				$('.pswp__video').each(function() {
					$(this).attr('src', $(this).attr('src'));
				});
				$(".video-section").css({
					"opacity": "0",
					"position": "absolute",
					"transform": "translateX(-3000px)"
				});
			});

			$(".video-section").css({
				"opacity": "1",
				"position": "static",
				"transform": "none"
			});

		};

		var galleryElements = document.querySelectorAll(gallerySelector);

		for (var i = 0, l = galleryElements.length; i < l; i++) {
			galleryElements[i].setAttribute('data-pswp-uid', i + 1);
			galleryElements[i].onclick = onThumbnailsClick;
		}

		var hashData = photoswipeParseHash();
		if (hashData.pid && hashData.gid) {
			openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
		}

	};


	initPhotoSwipeFromDOM('.photoswipe-wrapper');

	anchors();
	calculator();
	currencyDropdown();
	gallery();
	videoGallery();
	shareOpener();
	stickyNavigation();

});


// WEBPACK FOOTER //
// src/js/bundle/estate.js